const FORM_REQUIRED_FIELD = 'Обязательное поле'
const FORM_INVALID_EMAIL = 'Некорректный email '

export {
  FORM_REQUIRED_FIELD,
  FORM_INVALID_EMAIL,
}